export const menuData = ({
  i18n,
  t,
  SubMenuItem,
  openHome,
  setOpenHome,
  openServices,
  setOpenServices,
  openTarget,
  setOpenTarget,
  openIter,
  setOpenIter,
  openInnovation,
  setOpenInnovation,
}) => {
  const careers =
    i18n.language === 'it'
      ? 'https://www.fincantieri.com/it/lavora-con-noi/'
      : 'https://www.fincantieri.com/en/careers/';

  const p4f_batteries =
    i18n.language === 'it'
      ? 'https://www.power4future.it'
      : 'https://www.power4future.it';
  return [
    {
      exact: false,
      to: '/home',
      openCloseValue: openHome,
      openCloseCallback: setOpenHome,
      labelLink: t('menu.home'),
      subMenu: (
        <SubMenuItem
          title={t('menu.home')}
          closeCallback={setOpenHome}
          subMenuList={[
            { title: t('home.whoweare'), linkTo: '/home/whoweare' },
            { title: t('home.mission'), linkTo: '/home/mission' },
            { title: t('home.operating'), linkTo: '/home/operating' },
          ]}
        />
      ),
    },
    {
      exact: false,
      to: '/target',
      openCloseValue: openTarget,
      openCloseCallback: setOpenTarget,
      labelLink: t('menu.target'),
      subMenu: (
        <SubMenuItem
          title={t('menu.target')}
          closeCallback={setOpenTarget}
          subMenuList={[
            {
              keyName: 'shipboard',
              title: t('target.shipboard'),
              linkTo: '/target/shipboard',
              subMenuListItems: [
                {
                  linkTo: '/target/shipboard/propulsion',
                  title: t('shipboard.propulsion'),
                },
                {
                  linkTo: '/target/shipboard/energy',
                  title: t('shipboard.energy'),
                },
                {
                  linkTo: '/target/shipboard/electro',
                  title: t('shipboard.electro'),
                },
                {
                  linkTo: '/target/shipboard/shiptoshore',
                  title: t('shipboard.shiptoshore'),
                },
              ],
            },
            {
              keyName: 'equipment',
              title: t('target.plants'),
              linkTo: '/target/equipment',
              subMenuListItems: [
                {
                  linkTo: '/target/equipment/cold',
                  title: t('shipboard.cold'),
                },
                {
                  title: t('target.land'),
                  linkTo: '/target/equipment/land',
                },
              ],
            },
            {
              keyName: 'industrial',
              title: t('target.industrial'),
              linkTo: '/target/industrial',
            },
            {
              keyName: 'lyiecycle',
              title: t('target.lifecycle'),
              linkTo: '/target/lifecycle',
            },
          ]}
        />
      ),
    },
    {
      exact: false,
      to: '/innovation',
      labelLink: t('menu.innovation'),
    },
    {
      exact: false,
      to: '/iter',
      labelLink: t('menu.iter'),
    },
    {
      exact: false,
      target: '_blank',
      to: { pathname: p4f_batteries },
      labelLink: t('menu.p4f_batteries'),
    },
    {
      exact: false,
      to: '/certificates',
      labelLink: t('menu.certificates'),
    },
    {
      exact: false,
      to: '/media',
      labelLink: t('menu.media'),
    },
    {
      exact: false,
      target: '_blank',
      to: { pathname: careers },
      labelLink: t('menu.careers'),
    },
    {
      exact: false,
      to: '/contacts',
      labelLink: t('menu.contacts'),
    },
  ];
};
